import {
  CheckOutlined,
  MessageOutlined,
  PlusOutlined,
  WarningTwoTone,
} from "@ant-design/icons";
import { Button } from "antd";
import React, { useState } from "react";
import { $t } from "~/i18n.js";

import { testDateIsToday } from "~/lib/localize.js";
import { MaintenanceStatusTag, MeldingStatusTag } from "../../materialTags.jsx";
import { AddInspection } from "./addInspection.jsx";
import { CheckinModal } from "./checkinModal.jsx";
import { Inspection } from "./inspection.jsx";
import { DescriptionRow } from "~/components/descriptionRow/descriptionRow.jsx";
import { StartIcon } from "~/components/icon/icon.jsx";
import { DamageInspectionModal } from "~/pages/materiaal/tabs/status/damageInspectionModal.jsx";
import { hasDamageSchematic } from "~/pages/materiaal/tabs/status/damageSchematic.js";

export const MaterialStatusDescription = ({
  currentMaterial,
  inspection,
  last_motor_minutes,
  currentProfile,
  readOnly = true,
}) => {
  const [openInspection, setOpenInspection] = useState(false);
  const [openDamageInspection, setOpenDamageInspection] = useState(false);
  const [openCheckin, setOpenCheckinModal] = useState(false);
  const [hasCheckedIn, setHasCheckedIn] = useState(false);
  
  const isBrevet = currentProfile?.allow_inpect
  const isInspected = testDateIsToday(inspection?.date_created);
  return (
    <div>
      {openInspection && (
        <AddInspection
          currentMaterial={currentMaterial}
          closeModal={() => setOpenInspection(false)}
          visible={openInspection}
          last_motor_minutes={last_motor_minutes}
        />
      )}

      {openDamageInspection && (
        <DamageInspectionModal
          material={currentMaterial}
          closeModal={() => setOpenDamageInspection(false)}
        />
      )}

      {/* Checkin Modal */}
      {openCheckin && (
        <CheckinModal
          visible={openCheckin}
          onClose={(success) => {
            setOpenCheckinModal(false);
            if (success) {
              setHasCheckedIn(true);
              setTimeout(() => setHasCheckedIn(false), 5000);
            }
          }}
          currentMaterial={currentMaterial}
        />
      )}

      <div style={{ marginBottom: 12, maxWidth: 300 }}>
        <DescriptionRow label={$t("Status")}>
          <MeldingStatusTag status={currentMaterial.status} />
        </DescriptionRow>

        {currentMaterial.maintenance_status !== "" && (
          <DescriptionRow label={$t("Maintenance")}>
            <MaintenanceStatusTag
              maintenance_status={currentMaterial.maintenance_status}
              default_value="nvt"
            />
          </DescriptionRow>
        )}

        {currentMaterial.document_status !== "" && (
          <DescriptionRow label={$t("Documenten")}>
            <MaintenanceStatusTag
              maintenance_status={currentMaterial.document_status}
              default_value="nvt"
            />
          </DescriptionRow>
        )}

        {currentMaterial.enable_inspections && (
          <DescriptionRow label={$t("Dagelijkse inpectie")}>
            {isInspected ? (
              <Inspection
                inspection={inspection}
                currentUserID={currentProfile?.id}
                currentUserRole={currentMaterial.current_role}
                currentMaterial={currentMaterial}
                last_motor_minutes={last_motor_minutes}
              />
            ) : readOnly ? (
              <Inspection
                inspection={inspection}
                missingText={$t("Niet uitgevoerd")}
              />
            ) : (
              <>
                {isBrevet ? (
                  <Button
                    size="small"
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setOpenInspection(true)}
                  >
                    {$t("Inspecteer")}
                  </Button>
                ) : (
                  <p>
                    <WarningTwoTone
                      twoToneColor="red"
                      style={{ marginRight: 6 }}
                    />
                    {$t("Alleen voor brevethouders")}
                  </p>
                )}
              </>
            )}
          </DescriptionRow>
        )}

        {currentMaterial?.enable_damage_schematic && hasDamageSchematic(currentMaterial) && (
          <DescriptionRow label={$t("Schade meldingen")}>
            <Button
              size="small"
              type="secondary"
              onClick={() => setOpenDamageInspection(true)}
            >
              {$t("Bekijk schadekaart")}
            </Button>
          </DescriptionRow>
        )}

        {currentMaterial.kist_id && currentMaterial.enable_checkin && (
          <DescriptionRow label={$t("Check-in")}>
            <Button
              size="small"
              type={
                hasCheckedIn ? "default" : isInspected ? "primary" : "default"
              }
              icon={
                hasCheckedIn ? <CheckOutlined /> : <StartIcon />
              }
              onClick={() => setOpenCheckinModal(true)}
              disabled={hasCheckedIn}
            >
              {hasCheckedIn ? $t("Ingechecked") : $t("Check-in")}
            </Button>
          </DescriptionRow>
        )}

        {currentMaterial.remark && (
          <DescriptionRow>
            <MessageOutlined style={{ marginRight: 4 }} />{" "}
            {currentMaterial.remark}
          </DescriptionRow>
        )}
      </div>
    </div>
  );
};
